import { Box, styled, Typography } from '@mui/material';
import { fontFamily } from '@/@mui/tokens/font-family';
import { fontWeights } from '@/@mui/tokens/font-weights';

export const StyledButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isDisabled',
})<{ isSelected: boolean; isDisabled: boolean }>(
  ({ theme, isSelected, isDisabled }) => ({
    width: '100%',
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${
      isSelected ? theme.palette.neutral.darker : theme.palette.neutral.light
    }`,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.5 : 1,
    transition: 'all 0.2s',
    position: 'relative',
    '&:hover': { backgroundColor: theme.palette.neutral.lighter },
    '&:active': { backgroundColor: theme.palette.neutral.light },
  })
);

export const AbsoluteBox = styled(Box)({
  position: 'absolute',
  top: 16,
  right: 24,
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  fontFamily: fontFamily.fontFamilyCarbona,
  fontWeight: fontWeights.fontWeightSemibold,
  color: theme.palette.neutral[600],
}));

export const ToggleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'circle',
})<{ isSelected: boolean; circle?: boolean }>(
  ({ theme, isSelected, circle }) => ({
    width: 18,
    height: 18,
    borderRadius: circle ? '50%' : 4,
    border: `1px solid ${
      isSelected ? theme.palette.neutral.darker : theme.palette.neutral.light
    }`,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: isSelected ? theme.palette.neutral.darker : 'transparent',
    justifyContent: 'center',
  })
);
